import { useEffect } from 'react';
import { trpc } from '../lib/trpc/trpc';

// Once per session per kit
const prewarmed = new Set<string>();

export function usePrewarmAiChat(kitId?: string) {
  useEffect(() => {
    if (!kitId || prewarmed.has(kitId)) return;
    prewarmed.add(kitId);
    // Fire-and-forget; httpLink attaches auth headers. On failure the first
    // message lazily fetches, so swallowing the error is safe.
    trpc.resultsPortal.prewarmChatContext.mutate({ kitId }).catch(() => {});
  }, [kitId]);
}
